import { statusOptionsWithChildren, statusOptionWithParent } from 'AdminUsers/StatusOptions';

/*
    `failed` students are always listed. `expelled` and `withdrawn` students are listed too, and the
    "Show expelled/withdrawn" switch hides them in the browser. That check uses
    hasBeenExpelledOrWithdrawn, so any other will-not-graduate status added here would also count
    as expelled.
*/
export const GRADEBOOK_STATUSES = [
    ...statusOptionsWithChildren(['registered', 'matriculated', 'graduated']),
    ...statusOptionWithParent('failed'),
    ...statusOptionWithParent('expelled'),
    ...statusOptionWithParent('withdrawn'),
];

// The whole cohort comes back in one response, and the table pages it in the browser.
export const ALL_RECORDS = Number.MAX_SAFE_INTEGER;

// Cohorts that started before this date had participation scores.
export const PARTICIPATION_SCORE_CUTOFF = new Date('2017/09/01');

export const FILTERS_STORAGE_KEY = 'adminCohortGradebook';

export const SHOW_EXPELLED_PARAM = 'show-expelled';
export const QUICK_FILTER_PARAM = 'quick-filter-user';
export const USER_ID_PARAM = 'user_id';
export const REQUIREMENT_IDENTIFIER_PARAM = 'requirement_identifier';

export const LOAD_ERROR_MESSAGE = 'Failed to load students. Please try again.';
export const SAVE_ERROR_MESSAGE = 'Failed to save. Please try again.';
export const EXAM_LOAD_ERROR_MESSAGE = 'Failed to load the exam lesson scores. Please try again.';
export const COHORT_EXAMS_LOAD_ERROR_MESSAGE = "Failed to load the cohort's exams. Please try again.";
